import React, { memo } from 'react';
import { useParams } from 'react-router-dom';
import locator from 'utils/locator';
import urls from 'constants/urls';
import { MealDealId } from 'redux/modules/meal-deals/types';
import {
  tacticalIdToStrategicIdRedirectMap,
  strategicIdToPreservedTacticalIdRedTextMap,
} from 'redux/modules/meal-deals/selectors/meal-deal-data';
import Redirect from 'components/Redirect';
import MealDealPage from '.';

const getIdRedirect = (mealDealId: string) =>
  tacticalIdToStrategicIdRedirectMap[mealDealId] ??
  strategicIdToPreservedTacticalIdRedTextMap[mealDealId] ??
  null;

const StrategicMealDealPage = memo(() => {
  const { mealDealId } = useParams<{ mealDealId: MealDealId }>();

  if (!mealDealId) {
    return (
      <Redirect
        to={{
          pathname: urls.mealDealDineIn,
          search: locator.search,
        }}
        replace
        status={301}
      />
    );
  }

  const idRedirect = getIdRedirect(mealDealId);

  if (idRedirect) {
    return (
      <Redirect
        to={{
          pathname: `${urls.mealDealPromoPath}/${idRedirect}`,
          search: locator.search,
        }}
        replace
        status={301}
      />
    );
  }

  return <MealDealPage id={mealDealId} />;
});

StrategicMealDealPage.displayName = 'StrategicMealDealPage';

export default StrategicMealDealPage;
